import { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider } from './lib/auth';
import { ApiProvider } from './lib/apiContext';
import { api } from './lib/api';
import { createAppRouter } from './app/router';

// Screens view another system (site plugins/logs/deploys change out from under us) —
// keep queries fresh: staleTime > 0 dedupes a drill-down's fan-out, refetch covers re-entry/focus/reconnect.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 15_000,
      refetchOnMount: 'always',
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      // Background poll so a screen left open drifts by at most a minute.
      refetchInterval: 60_000,
      refetchIntervalInBackground: false,
    },
  },
});

export function App() {
  const router = useMemo(() => createAppRouter({ history: 'browser' }), []);
  return (
    <QueryClientProvider client={queryClient}>
      <ApiProvider client={api}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ApiProvider>
    </QueryClientProvider>
  );
}
